const nestedRowsStructure = {
  data() {
    return {
      // Example value:
      // {id строки родителя:{"show":true,"children":[...id дочерних строк]},
      // {"50":{"show":true,"children":[52,53,54]},"55":{"show":true,"children":[56,57]}}
      nestedRowsStructure: null,
      // Example value: [...id скрытых строк], [56,57,52,53,54]
      hiddenRows: [],
      childRows: [],
    };
  },
  methods: {
    toggleNestedRows(row, rows) {
      if (row.row.group_level) {
        if (!this.nestedRowsStructure) {
          // Структура создается только при первой попытке свернуть группу, чтобы жестко не
          // отслеживать момент загрузки данных и не формировать лишние структуры при их ненадобности
          this.createNestedRowsStructure(rows);
        }
        const rowInfo = this.nestedRowsStructure[row.id];
        // Если на данный момент группа показывается, то добавляем всех дочерние
        // строки в список скрытых, иначе удаляем их оттуда
        if (rowInfo?.show) {
          this.hiddenRows = [...this.hiddenRows, ...rowInfo?.children];
        } else {
          this.hiddenRows = this.hiddenRows.filter((row) => !rowInfo.children.includes(row));
        }
        this.nestedRowsStructure[row.id].show = !rowInfo.show;
      }
    },
    createNestedRowsStructure(rows) {
      // Пример сгенерированной структуры: {id строки родителя:{"show":true,"children":[...id дочерних строк]},
      // {"50":{"show":true,"children":[52,53,54]},"55":{"show":true,"children":[56,57]}}
      this.nestedRowsStructure = {};
      let currentParentRow = null;
      this.childRows = [];
      rows.forEach((row) => {
        row = row?.row ? row.row : row;
        if (row?.group_level) {
          this.nestedRowsStructure[row.id] = { show: true, children: [] };
          currentParentRow = row.id;
        } else if (currentParentRow) {
          this.nestedRowsStructure[currentParentRow].children.push(row.id);
          this.childRows.push(row.id);
        }
      });
    },
    isTurnOverArrow(row) {
      const show = this.nestedRowsStructure?.[row?.id]?.show;
      if (show === undefined) {
        return true;
      }
      return show;
    },
    indexRows(list) {
      let itemNo = 0;
      let lastGroupIndex = null;
      let lastSubItemIndex = 0;
      list?.rows?.forEach((row) => {
        // группа
        row = row?.row ? row.row : row;
        if (row.group_level) {
          // groups++;
          // row.groupNo = this.countGroup(row.group_level, list.order);
          itemNo++;
          row.groupNo = itemNo;
          lastSubItemIndex = 0;
          lastGroupIndex = itemNo;
        } else {
          // позиция
          if (lastGroupIndex) {
            lastSubItemIndex++;
            row.groupNo = `${lastGroupIndex}.${lastSubItemIndex}`;
          } else {
            itemNo++;
            row.groupNo = itemNo;
          }
          row.lastUpdate = new Date().toString();
        }
      });
      return list;
    },
  },
};

export default nestedRowsStructure;
